export default __webpack_public_path__ + "static/yonder-screenshot-f0fe8fdd8ae2af822676289cd10bfc2f.png";